import { render, staticRenderFns } from "./copyLinkDialog.vue?vue&type=template&id=2966dd3c&scoped=true&"
import script from "./copyLinkDialog.vue?vue&type=script&lang=js&"
export * from "./copyLinkDialog.vue?vue&type=script&lang=js&"
import style0 from "./copyLinkDialog.vue?vue&type=style&index=0&id=2966dd3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2966dd3c",
  null
  
)

export default component.exports